import createError from '../createError';

export function booleanValidators(value: boolean, field: string) {
  return {
    boolean: () => boolean(value, field),
    isTrue: () => isTrue(value, field),
    isFalse: () => isFalse(value, field),
  };
}

const boolean = (value: boolean, field: string) => {
  return createError(
    value,
    field,
    'boolean',
    (value: boolean) => typeof value !== 'boolean'
  );
};

const isTrue = (value: boolean, field: string) => {
  return createError(
    value,
    field,
    'isTrue',
    (value: boolean) => value === false
  );
};

const isFalse = (value: boolean, field: string) => {
  return createError(
    value,
    field,
    'isFalse',
    (value: boolean) => value === true
  );
};
